export const CHANGE_CURRENT_PAGE = 'authorizeSettings/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'authorizeSettings/CHANGE_PAGE_SIZE'
export const CREATE_AUTHORIZE_SETTING = 'authorizeSettings/CREATE_AUTHORIZE_SETTING'
export const FETCH_AUTHORIZE_SETTINGS_LIST = 'authorizeSettings/FETCH_AUTHORIZE_SETTINGS_LIST'
export const FETCH_AUTHORIZE_SETTINGS_FOR_OPTIONS = 'authorizeSettings/FETCH_AUTHORIZE_SETTINGS_FOR_OPTIONS'
export const REMOVE_AUTHORIZE_SETTING = 'authorizeSettings/REMOVE_AUTHORIZE_SETTING'
export const UPDATE_AUTHORIZE_SETTING = 'authorizeSettings/UPDATE_AUTHORIZE_SETTING'
